import Typography from "@/components/shared/Typography"
import Image from "next/image"
import { useRouter } from "next/navigation"
import { FC } from "react"
interface Props {
  closeModal: () => void
}
export const LocationLockedRewardModal: FC<Props> = ({ closeModal }) => {
  const { push } = useRouter()

  return (
    <div className="flex flex-col">
      <div className="mb-4">
        <Image src="/assets/images/banner_mobile_sm.png" width={300} height={235} alt="" className="mx-auto" />
      </div>
      <Typography type="h4" className="mb-2 text-primary-700">
        Zamčená odměna
      </Typography>

      <Typography type="l" className="mb-8 text-primary-400">
        Pro odemknutí odměny si musíš stáhnout naši mobilní aplikaci, ve které pak na místě kde se komiks odehrává
        potvrdíš svojí lokaci.
      </Typography>

      <div className="flex w-full flex-row justify-between gap-2">
        <div>
          <Image src="/assets/images/apple.svg" width={120} height={40} alt="" className="mr-4" />
        </div>

        <div>
          <Image src="/assets/images/googlePlay.svg" width={135} height={40} alt="" />
        </div>
      </div>
    </div>
  )
}
